import React from "react";
import "./Terms&Conditions.css";
import { renderStatementWithKaTeX } from "../../Status";



const TermsAndConditions = () => {
  return (
    <div className="terms-container">
        
      <div className="terms-card">
        <span className="floating-symbol pi">
                  {renderStatementWithKaTeX("$\\pi$")}
                </span>
                <span className="floating-symbol sigma">
                  {renderStatementWithKaTeX("$\\sum$")}
                </span>
                <span className="floating-symbol infinity">
                  {renderStatementWithKaTeX("$\\infty$")}
                </span>
                <span className="floating-symbol sqrt">
                  {renderStatementWithKaTeX("$\\sqrt{}$")}
                </span>
                <span className="floating-symbol integral">
                  {renderStatementWithKaTeX("$\\int$")}
                </span>
                <span className="floating-symbol plusminus">
                  {renderStatementWithKaTeX("$\\pm$")}
                </span>
                <span className="floating-symbol prod">
                  {renderStatementWithKaTeX("$\\prod$")}
                </span>
                <span className="floating-symbol R">
                  {renderStatementWithKaTeX("$\\mathbb{R}$")}
                </span>
        <h1 className="terms-title">Terms and Conditions</h1>
        <div className="terms-content">
          <section>
            <h2>1. Acceptance of Terms</h2>
            <p>
              By accessing and using this website, you agree to comply with and
              be bound by these Terms and Conditions. If you do not agree, please
              refrain from using the site.
            </p>
          </section>

          <section>
            <h2>2. User Responsibilities</h2>
            <p>
              You agree to use the website in compliance with applicable laws and
              regulations. Any misuse, including but not limited to unauthorized
              access, data manipulation, or harmful activities, is strictly
              prohibited.
            </p>
          </section>

          <section>
            <h2>3. Accounts and Security</h2>
            <p>
              When creating an account, you must provide accurate information. You
              are responsible for maintaining the confidentiality of your account
              credentials and any activity that occurs under your account.
            </p>
          </section>

          <section>
            <h2>4. Content Ownership</h2>
            <p>
              All content, materials, and resources on this site are protected by
              intellectual property laws. You may not copy, reproduce, or
              distribute content without prior written consent.
            </p>
          </section>

          <section>
            <h2>5. Limitation of Liability</h2>
            <p>
              We are not responsible for any direct, indirect, or consequential
              damages resulting from the use of this site. The site is provided
              "as is" without warranties of any kind.
            </p>
          </section>

          <section>
            <h2>6. Changes to Terms</h2>
            <p>
              We reserve the right to update these Terms and Conditions at any
              time. Continued use of the site after modifications means you accept
              the updated terms.
            </p>
          </section>

          <section>
            <h2>7. Contact Us</h2>
            <p>
              If you have any questions about these Terms and Conditions, please
              contact us at{" "}
              <a href="mailto:support@mathtounsi.com">support@mathtounsi.com</a>.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
